import { request } from "common/components/request";
import { DOWNLOAD_REPORT } from "common/actions/common";
import {
    FETCH_DOWNLOADS_START,
    FETCH_DOWNLOADS_SUCCESS,
    MARK_DOWNLOAD_START,
    MARK_DOWNLOAD_SUCCESS,
    MARK_ALL_DOWNLOADS_READ_SUCCESS,
    SHOW_EXPORT_DIALOG,
    SET_EXPORT_DIALOG_CONFIGURATION,
    CLEAR_AUTOMATIC_DOWNLOAD
} from "../reducers/downloads";

export const FETCH_DOWNLOADS = function() {
    return (dispatch, getState) => {
        if (getState().common.merchant_ref) {
            dispatch(FETCH_DOWNLOADS_START());
            return request("/merchant/:merchant_ref/user/notification/").then((data) => {
                dispatch(FETCH_DOWNLOADS_SUCCESS(data));
            }).then(() => {
                const automatic_download = getState().downloads.automatic_download;
                const availableDownloads = getState().downloads.downloads_data.filter((notification) => automatic_download.includes(notification.refs.job));
                
                const getFiles = (files) => {
                    const file = files.shift();
                    if (file) {
                        dispatch(CLEAR_AUTOMATIC_DOWNLOAD(file.refs.job));
    
                        dispatch(DOWNLOAD_REPORT(file.refs.job));

                        return Promise.delay(1000).then(() => getFiles(files));
                    }

                    return Promise.resolve();
                };

                return getFiles(availableDownloads);
            });
        }
        
        return Promise.resolve();
    };
};

export const MARK_DOWNLOAD_READ = function(id) {
    return (dispatch, getState) => {
        dispatch(MARK_DOWNLOAD_START());
        return request(`/merchant/:merchant_ref/user/notification/${id}`, {
            method: "PUT",
            data: { acknowledged: true }
        }).then(() => {
            dispatch(MARK_DOWNLOAD_SUCCESS(id));
        });
    };
};

export const MARK_ALL_DOWNLOADS_READ = function() {
    return (dispatch, getState) => {
        dispatch(MARK_DOWNLOAD_START());
        return request("/merchant/:merchant_ref/user/notification/?clear=report_export", {}).then(() => {
            dispatch(MARK_ALL_DOWNLOADS_READ_SUCCESS());
        });
    };
};

export const OPEN_EXPORT_DIALOG = (configuration, exporter) => (dispatch, getState) => {
    const automaticDownload = getState().common.user.superuser;
    configuration.initialState = {
        ...configuration.initialState,
        hasAutomaticDownload: automaticDownload,
        automaticDownload
    };
    const defaultConfig = {
        close: CLOSE_EXPORT_DIALOG
    };
    dispatch(SET_EXPORT_DIALOG_CONFIGURATION({
        ...defaultConfig,
        ...configuration,
        ...exporter && { exporter }
    }));
    dispatch(SHOW_EXPORT_DIALOG(true));
};

export const CLOSE_EXPORT_DIALOG = function() {
    return (dispatch, getState) => {
        dispatch(SHOW_EXPORT_DIALOG(false));
    };
};
